<template>
 <el-dialog :visible.sync="dialogFormVisible">
    <pt-form-item label="资质证照名称：" labelWidth="120px" :required="true">
        <el-input name="name" data-vv-as="资质证照名称" v-validate="'required'" v-model="aFile.name" placeholder="请输入资质证照名称"></el-input>
        <wt-upload-file :action="uploadApi" :data="pictureParams" :img-url="privateResourcesUrl" listType="text"
          v-model="aFile.url" :multiple="false" :class="$style['dialog-upload']" accept="image/png,image/jpeg">
          <el-button size="small" type="primary">点击上传</el-button>
        </wt-upload-file>
    </pt-form-item>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="certain">确 定</el-button>
  </div>
</el-dialog>

</template>

<script>
import { validate } from 'utils/validate'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    uploadApi: {
      type: String,
      required: true
    },
    pictureParams: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      aFile: {
        url: ''
      },
      dialogFormVisible: this.showDialog,
      fileList: [],
      privateResourcesUrl: this.$privateResourcesUrl
    }
  },
  watch: {
    showDialog (val) {
      this.dialogFormVisible = val
    },
    dialogFormVisible (val) {
      this.$emit('updateVisible', val)
    }
  },
  methods: {
    certain () {
      validate(this, this.aFile).then(formValue => {
        this.dialogFormVisible = false
        let { name, url } = this.aFile
        let file = {
          url: url.response,
          name
        }
        this.$emit('getFile', file)
        this.reset()
      })
    },
    reset () {
      this.aFile = { url: '' }
    }
  }
}
</script>

<style module lang="less">
.dialog-upload{
    display: inline-block;
    margin-left: 20px;
}
</style>
